import { createElement } from "react";
import { toast as sonner } from "sonner";
import { http } from "./api";
import { saveDraftsForReturn } from "./navDraft";

const trLower = (s) => String(s || "").toLocaleLowerCase("tr-TR");
export const currentBack = () => window.location.pathname + window.location.search;

// aynı sayfa + ?kayit=<id> (mevcut filtreler korunur)
export function recordLink(id, path) {
  if (!id) return null;
  const u = new URL(path || currentBack(), window.location.origin);
  u.searchParams.set("kayit", id);
  return u.pathname + u.search;
}

// listede ilgili satırı bul, kaydır ve sarı yanıp söndür (liste geç yükleniyorsa yeniden dener; satır yeniden çizilirse sınıf yeniden eklenir); iptal fonksiyonu döner
export function flashRecord(id, tries = 15) {
  let n = 0, t = null, keep = null;
  const sel = `[data-flash-id="${id}"], [data-testid$="-row-${id}"]`;
  const attempt = () => {
    const el = document.querySelector(sel);
    if (el) {
      el.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" });
      const until = Date.now() + 4500;
      const apply = () => { const cur = document.querySelector(sel); if (cur) cur.classList.add("flash-row"); };
      apply();
      keep = setInterval(() => { if (Date.now() > until) { clearInterval(keep); document.querySelector(sel)?.classList.remove("flash-row"); } else apply(); }, 300);
      return;
    }
    if (++n < tries) t = setTimeout(attempt, 400);
  };
  t = setTimeout(attempt, 300);
  return () => { clearTimeout(t); if (keep) clearInterval(keep); };
}

// ?odak=<anahtar> → [data-odak="<anahtar>"] öğesine kaydır, odakla, yanıp söndür ("geldiğim hücrenin üzerine dön"); bulununca onFound; iptal fonksiyonu döner
export function focusOdak(key, onFound, tries = 15) {
  if (!key) return () => {};
  let n = 0, t = null;
  const sel = `[data-odak="${CSS.escape(key)}"]`;
  const attempt = () => {
    const el = document.querySelector(sel);
    if (el) {
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      el.focus?.({ preventScroll: true });
      el.classList.add("flash-row");
      setTimeout(() => el.classList.remove("flash-row"), 4500);
      onFound?.();
      return;
    }
    if (++n < tries) t = setTimeout(attempt, 400);
  };
  t = setTimeout(attempt, 300);
  return () => clearTimeout(t);
}


// hedefe git: aynı görünümde yalnız kayıt vurgulanır; farklı ekrana giderken açık form taslakları saklanır (ESC ile dönüşte geri yüklenir)
export function go(href, back) {
  const target = href.replace("__BACK__", encodeURIComponent(back || currentBack()));
  const u = new URL(target, window.location.origin);
  const cur = new URL(window.location.href);
  const strip = (sp) => [...sp].filter(([k]) => k !== "kayit" && k !== "don" && k !== "odak").sort().join("&");
  if (u.pathname === cur.pathname && strip(u.searchParams) === strip(cur.searchParams) && u.searchParams.get("kayit")) {
    flashRecord(u.searchParams.get("kayit"));
    return;
  }
  saveDraftsForReturn(back || currentBack());
  if (window.__pasNav) window.dispatchEvent(new CustomEvent("pas:navigate", { detail: u.pathname + u.search }));
  else window.location.href = target;
}

// ---- alan bulma: mesajdaki etiketten form alanına ----
const STOP = [" zorunlu", " girin", " giriniz", " girilmeli", " seçin", " seçiniz", " seçilmeli", " geçersiz", " boş", " olmalı", " hatalı", " eksik", " gerekli", " bulunamadı", " tanımlı değil", " aşıyor", " uyuşmuyor", " kabul edilmez", " desteklenmiyor", " yetersiz", " dolu"];
function phraseOf(msg) {
  let m = trLower(msg).replace(/^lütfen\s+/, "");
  let cut = m.length;
  for (const s of STOP) { const i = m.indexOf(s); if (i > 0 && i < cut) cut = i; }
  return m.slice(0, cut).replace(/[*:"'()—–-]/g, " ").replace(/\s+/g, " ").trim();
}
const labelText = (el) => { const sp = el.querySelector(":scope > span"); return trLower((sp ? sp.textContent : el.textContent).replace(/\*|\(otomatik\)|\(opsiyonel\)/g, "")).trim(); };
const CONTROL = "input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button[role=combobox], [data-searchable] input, [data-searchable] button";
function controlOf(label) {
  if (label.htmlFor) { const c = document.getElementById(label.htmlFor); if (c) return c; }
  const inner = label.querySelector(CONTROL);
  if (inner) return inner;
  const nx = label.nextElementSibling;
  return nx && (nx.matches(CONTROL) ? nx : nx.querySelector?.(CONTROL)) || null;
}
export function findFieldByMessage(msg) {
  const phrase = phraseOf(msg);
  if (phrase.length < 3) return null;
  let best = null, bestLen = 0;
  const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const wordIn = (hay, needle) => new RegExp(`(^|[\\s(])${esc(needle)}($|[\\s)])`, "u").test(hay);
  const consider = (t, getControl) => {
    const base = t.replace(/\s*\(.*?\)\s*/g, " ").replace(/\s+/g, " ").trim();
    if (base.length < 3) return;
    const score = base === phrase ? 1000 : wordIn(phrase, base) ? 500 + base.length : wordIn(base, phrase) ? 100 + base.length : wordIn(phrase, t) ? 50 + t.length : 0;
    if (score > bestLen) { const c = getControl(); if (c) { best = c; bestLen = score; } }
  };
  for (const l of document.querySelectorAll("label")) {
    if (l.offsetParent !== null) consider(labelText(l), () => controlOf(l));
  }
  // <label> kullanmayan satırlar: <div><span>Etiket</span><div><input/></div></div>
  for (const sp of document.querySelectorAll("div > span:first-child")) {
    if (sp.offsetParent === null || sp.closest("label") || sp.textContent.length > 40) continue;
    const t = trLower(sp.textContent.replace(/\*/g, "")).trim();
    consider(t, () => { const c = sp.parentElement.querySelector(CONTROL); return c && !sp.contains(c) ? c : null; });
  }
  return best;
}
const NAME_ALIASES = { loan_no: "no", invoice_no: "no", check_no: "no", card_no: "no", tc_no: "tc", full_name: "name", interest_rate: "rate", installment_count: "count", monthly_installment: "monthly", start_date: "start", due_date: "due", entry_date: "date", purchase_date: "purchase-date", given_to: "given-to", gross_salary: "gross", net_salary: "net", hire_date: "hire" };
export function findFieldByName(name) {
  if (!name) return null;
  const kebab = String(name).replace(/_/g, "-");
  const cands = [kebab, NAME_ALIASES[name], kebab.replace(/-id$/, ""), kebab.split("-")[0]].filter(Boolean);
  for (const c of cands) {
    const el = document.querySelector(`[data-testid$="-field-${c}"], [data-testid$="-${c}"][data-testid*="field"], [name="${name}"]`);
    if (el && el.offsetParent !== null) return el.matches(CONTROL) ? el : el.querySelector(CONTROL) || el;
  }
  return null;
}
export function focusField(el) {
  el.scrollIntoView({ block: "center", behavior: "smooth" });
  const f = () => { try { el.focus({ preventScroll: true }); el.select?.(); } catch { /* odaklanamayan eleman */ } };
  f();
  // sonner, toast odağı kaybolunca önceki elemana (örn. Kaydet) geri döner — bir tık sonra alanı yeniden odakla
  setTimeout(() => { if (el.isConnected && document.activeElement !== el) f(); }, 80);
  el.classList.add("field-flash");
  setTimeout(() => el.classList.remove("field-flash"), 3000);
}

// ---- kayıt referansı: mesajdaki belge/çek/TC/kredi → sunucuda ara ----
const REF_RULES = [
  { re: /\b((?:SAS|THK)\d{6,})\b/, kind: "invoice_no" },
  { re: /\b([A-ZÇĞİÖŞÜ]{2,6}-\d{1,8}(?:[-/]\d{1,6})?)\b/, kind: "invoice_no" },
  { re: /çek no[:\s]+([^\s,)]+)/i, kind: "check" },
  { re: /(?:fatura|belge) (?:no|numarası)\D{0,3}([A-Za-z0-9/-]{2,})/i, kind: "invoice_no" },
  { re: /\b(\d{11})\b/, kind: "tc" },
  { re: /kredi(?:si)?\s*\(([^)]+)\)/i, kind: "loan" },
];
const SCREEN_RULES = [
  { re: /onay bekliyor|hizmet onayları|reddedilmiş/i, href: "/onaylar" },
  { re: /hakediş(?:i)? (?:oluşturulmuş|kilitli)|hakediş kilidi|hakedişe dahil/i, href: "/musteri-hakedis" },
];
const findRef = (msg) => { for (const r of REF_RULES) { const m = msg.match(r.re); if (m) return { kind: r.kind, ref: m[1] }; } return null; };
async function lookupAndGo(r, back) {
  try { const { data } = await http.get("/lookup", { params: { kind: r.kind, ref: r.ref } }); go(data.href, back); }
  catch (e) { sonner.error(e?.response?.data?.detail || "Kayıt bulunamadı"); }
}

// ---- tıklanabilir toast ----
const clickable = (msg, onClick, hint) => createElement("span", { onClick, onMouseDown: (e) => e.preventDefault(), "data-testid": "toast-msg", className: "cursor-pointer block" },
  msg, createElement("span", { className: "block mt-0.5 text-[11px] font-semibold underline opacity-80", "data-testid": "toast-hint" }, hint));

function withLinks(level, msg, links, back, rest) {
  const parts = []; let r = msg;
  for (const l of links) {
    const i = r.indexOf(l.text);
    if (i < 0) continue;
    parts.push(r.slice(0, i));
    parts.push(createElement("button", { key: l.href, type: "button", onClick: () => go(l.href, back), "data-testid": "toast-link", className: "underline font-bold text-sky-700 hover:text-sky-900" }, l.text));
    r = r.slice(i + l.text.length);
  }
  parts.push(r);
  return sonner[level](createElement("span", { "data-testid": "toast-error-msg" }, ...parts), { duration: 12000, action: { label: "Git", onClick: () => go(links[0].href, back) }, ...rest });
}

function show(level, msg, opts = {}) {
  const { link, links, field, hint, back, ...rest } = opts;
  if (typeof msg !== "string") return sonner[level](msg, rest);
  if (Array.isArray(links) && links.length) return withLinks(level, msg, links, back, rest);
  let onClick = null, label = null;
  if (link) { onClick = () => go(link, back); label = "Kayda Git"; }
  else if (field) {
    const el = typeof field === "string" ? document.querySelector(`[data-testid="${field}"]`) || findFieldByName(field) : field;
    if (el) { onClick = () => focusField(el); label = "Alana Git"; }
  }
  if (!onClick && level !== "success") {
    const el = findFieldByMessage(msg);
    if (el) { onClick = () => focusField(el); label = "Alana Git"; }
    else {
      const ref = findRef(msg);
      if (ref) { onClick = () => lookupAndGo(ref, back); label = "Kayda Git"; }
      else { const s = SCREEN_RULES.find((x) => x.re.test(msg)); if (s) { onClick = () => go(`${s.href}?odak=1&don=__BACK__`, back); label = "Ekrana Git"; } }
    }
  }
  if (!onClick) return sonner[level](msg, rest);
  return sonner[level](clickable(msg, onClick, hint || `${label} →`), { duration: level === "success" ? 6000 : 10000, action: { label, onClick }, ...rest });
}

export function toast(msg, opts) { return sonner(msg, opts); }
Object.assign(toast, sonner, {
  success: (m, o) => show("success", m, o),
  error: (m, o) => show("error", m, o),
  warning: (m, o) => show("warning", m, o),
  info: (m, o) => show("info", m, o),
});
window.__pasGo = go;
